module.exports = __webpack_public_path__ + "media/images/users/user-3-4a37313ead79cbc406ed447798b83f96.jpg";